import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import { FormLoader } from '../Loader/FormLoader'
import { useStyles } from './Styles'
import PageTitle from '../Dashboard/PageTitle/PageTitle'
import SettingForm from './SettingForm'

const SettingsContent = ({ getSettings }) => {
  const classes = useStyles()
  React.useEffect(() => {
      getSettings()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <>
      <PageTitle title={<FormattedMessage id='Sidebar.Links.Settings'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <AuthenticatedUserConsumer>
            {({ settings, settingsLoading, settingValueSubmit, adminSectionType }) => (
              <>
                {!!settingsLoading && <FormLoader loading={true}/>}
                {!!Object.keys(settings).length &&
                settings.map((setting, index) =>
                  <SettingForm key={setting.id}
                               index={index}
                               adminSectionType={adminSectionType}
                               setting={setting}
                               onSubmit={settingValueSubmit}
                  />)
                }
              </>

            )}
          </AuthenticatedUserConsumer>
        </Grid>
      </Grid>
    </>
  )
}

export default SettingsContent
